module.exports = __webpack_public_path__ + "img/shareupdate.108c9fa9.svg";